'use strict';

// https://262.ecma-international.org/6.0/#sec-toobject

module.exports = require('es-object-atoms/ToObject');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2015/ToObject.js
// module id = 464
// module chunks = 231608221292675